import product2 from '../../images/chicken-cheese.jpg';
import product3 from '../../images/hawaiian-peeksa.jpg';
import product4 from '../../images/steak-peeksa.jpg';
import app1 from '../../images/wings-w:-chives.jpg';
import app2 from '../../images/Southwestern-Cheeseburger-Sliders.jpg';
import app3 from '../../images/lil-sliders.jpeg';
import sweet1 from '../../images/chocolate-lava-cake.jpg';
import sweet2 from '../../images/Cinnamon-Rolls.jpg';
import sweet3 from '../../images/ice-cream-sandwich.jpg';

export const productData = [
    {
        img: product2,
        alt: 'chicken-Pizza',
        name: 'Chicken-N-Cheez',
        desc: 'Grilled Chicken Breast, basil, mozzarella, marinara sauce',
        price: '$16.99',
        button: 'Add to Cart'
    },
    {
        img: product3,
        alt: 'hawaiian-Pizza',
        name: 'Aloha Pie',
        desc: 'Marinara sauce, Diced Pineapple, Pepperoni, Fresh Mozzarella',
        price: '$16.99',
        button: 'Add to Cart'
    },
    {
        img: product4,
        alt: 'steak-pizza',
        name: 'Steak Pizza',
        desc: 'Sliced Ribeye Steak, Marainara Sauce, Banana Peppers, Fresh Tomatoes, Red Peppers, Onion, Mushrooms',
        price: '$21.99',
        button: 'Add to Cart'
    },
];

export const appData = [
    {
        img: app1,
        alt: 'chicken-wings',
        name: 'For The Wingz',
        desc: 'Double fried chicken wings smothered in our very own spicy buffalo sauce made in house.',
        price: '$12.99',
        button: 'Add to Cart'
    },
    {
        img: app2,
        alt: 'southwestern-sliders',
        name: 'Southwestern Cheeseburger Sliders',
        desc: 'Cheeseburger Sliders made with 100% REAL BEEF topped with our special Southwestern Chipotle Sauce made in house.',
        price: '$10.99',
        button: 'Add to Cart'
    },
    {
        img: app3,
        alt: 'sliders',
        name: 'Lil Sliders',
        desc: 'Homemade Sliders made with 100% REAL BEEF!',
        price: '$8.99',
        button: 'Add to Cart'
    },
];

export const sweetData = [
    {
        img: sweet1,
        alt: 'chocolate-lava-cake',
        name: 'Chocolate Lava Cake',
        desc: 'Homemade Chocolate Lava cake with warm and molten center.',
        price: '$6.99',
        button: 'Add to Cart'
    },
    {
        img: sweet2,
        alt: 'cinnamon-rolls',
        name: 'Walnut Cinammon Rolls',
        desc: 'Homemade Cinnamon Rolls baked to perfection and topped with chopped walnuts.',
        price: '$5.99',
        button: 'Add to Cart'
    },
    {
        img: sweet3,
        alt: 'ice-cream-cookie-sandwiches',
        name: 'Cookie Ice Cream Sandwiches',
        desc: 'Homemade Vanilla Ice Cream stuffed between two warm homemade cookies of your choice. (Sprinkles are optional)',
        price: '$6.99',
        button: 'Add to Cart'
    },
];